const today = new Date();

export const permissionariesInitialValues = {
  cdLinhaPermissionario: '',
  nuProcesso: '',
  nuProcessoSei: '',
  nuPermissionario: '',
  deCpfCnpj: '',
  deNomePermissionario: '',
  dePendencias: '',
  nuTermo: '',
  dtAssinatura: null,
  cdLinhaOutorga: '',
  dtPublicacao: null,
  dtInicioVigencia: null,
  dtVencimento: null,
  cdPermissionarioRefData: 1,
  deCnh: '',
  tpCategoriaCnh: 'A',
  nuPrazo: '',
  deTipoPrazo: 'Anos',
  // -----------------------
  deObservacao: '',
  boAtivo: true,
};

export const activateVehicleModalInitialValues = {
  dtAtualizacao: today,
  deObservacao: '',
};

export const adictiveDrawerInitialValues = {
  cdAditivo: null,
  cdLinha: null,
  cdLinhaPermissionario: null,
  cdTipoDocumento: null,
  nuAditivo: '',
  nuTermo: null,
  nuProcesso: '',
  nuProcessoSei: '',
  nuSolicitacao: '',
  dtEmissao: null,
  dtPublicacao: null,
  deObservacao: '',
  // documentos: '',
};
